var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$route.path!='/printTransportTicket')?_c('div',{staticClass:"app-page"},[_c('top'),_c('div',{staticClass:"holder1"}),_c('router-view'),_c('bottom',{staticClass:"footer"})],1):_c('div',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }